import { useCallback } from 'react'
import { closeModal, useAppDispatch } from '@open-tender/cloud'
import { CreditCardForm, ModalContent, ModalView } from 'components'

export interface CreditCardModalProps extends Record<string, unknown> {
  callback: () => void
  revenue_center_id: number
  RCrequire_cardholder_name: boolean
}

const CreditCard = ({
  windowRef,
  callback,
  revenue_center_id,
  RCrequire_cardholder_name,
}: CreditCardModalProps & { windowRef: React.RefObject<HTMLDivElement> }) => {
  const dispatch = useAppDispatch()

  const addCallback = useCallback(() => {
    if (callback) callback()
    dispatch(closeModal())
  }, [dispatch, callback])

  return (
    <ModalView>
      <ModalContent title="Add a new credit card">
        <CreditCardForm
          windowRef={windowRef}
          callback={addCallback}
          revenue_center_id={revenue_center_id}
          RCrequire_cardholder_name={RCrequire_cardholder_name}
        />
      </ModalContent>
    </ModalView>
  )
}

export default CreditCard
